import { useQuery } from '@tanstack/react-query'
import { dealerBackofficeGetDashboardSummaryOptions } from '@repo/sdk'

export function useDashboardSummary() {
  const { data, isLoading, isError, refetch } = useQuery({
    ...dealerBackofficeGetDashboardSummaryOptions(),
  })

  return {
    annualRevenue: data?.annualRevenue ?? { amount: 0, currency: 'KRW' },
    orderCounts: data?.orderCounts ?? {
      paymentPending: 0,
      paid: 0,
      shipped: 0,
      delivered: 0,
      confirmed: 0,
      allCancelled: 0,
    },
    pendingReturnsCount: data?.pendingReturnsCount ?? 0,
    pendingCancellationsCount: data?.pendingCancellationsCount ?? 0,
    isLoading,
    isError,
    refetch,
  }
}
